import { render, staticRenderFns } from "./station-list.vue?vue&type=template&id=587f4652&scoped=true&"
import script from "./station-list.vue?vue&type=script&lang=js&"
export * from "./station-list.vue?vue&type=script&lang=js&"
import style0 from "./station-list.vue?vue&type=style&index=0&id=587f4652&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f4652",
  null
  
)

export default component.exports